import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [order, setOrder] = useState({ number: "", fulfillment: "", pickup: "" });

  useEffect(() => {
    if (!sessionId) { setStatus("timeout"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setOrder({ number: data.order_number || "", fulfillment: data.fulfillment || "", pickup: data.pickup_location || "" });
        if (data.payment_status === "paid") { setStatus("paid"); return; }
      } catch {}
      if (tries++ < 10) setTimeout(poll, 2000); else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center">
      {status === "checking" && <><Loader2 className="w-12 h-12 animate-spin mx-auto text-[var(--gv-blue-bright)]" /><p className="mt-4 text-gray-300">Confirming your payment…</p></>}
      {status === "paid" && (
        <>
          <CheckCircle2 className="w-16 h-16 mx-auto text-green-400" />
          <p className="text-xs uppercase tracking-[0.25em] text-[var(--gv-blue-bright)] font-bold mt-4">Gray Collegiate Academy • War Eagles</p>
          <h1 className="font-display text-5xl mt-1">ORDER CONFIRMED</h1>
          <p className="mt-2 text-gray-300">Payment received. Thank you!</p>
          {order.fulfillment === "pickup" && order.pickup && <p className="mt-1 text-sm text-white font-bold" data-testid="pickup-location">Pickup: {order.pickup}</p>}
          {order.fulfillment === "shipping" && <p className="mt-1 text-sm text-white font-bold">Shipping via USPS to your address</p>}
          {order.number && <p className="mt-4 text-sm">Order # <span className="font-bold text-[var(--gv-blue-bright)]" data-testid="order-number">{order.number}</span></p>}
          <p className="mt-6 text-xs text-gray-500">You'll be notified when your GCA War Eagles gear is ready. Powered by Dad Jerzeys.</p>
          <Link to="/" className="inline-block mt-8 bg-[var(--gv-blue)] hover:bg-[var(--gv-blue-bright)] text-black px-8 py-4 font-bold uppercase tracking-widest text-sm transition-colors">Back to Store</Link>
        </>
      )}
      {status === "timeout" && <p className="text-gray-300">Payment is processing. Check your email for confirmation.</p>}
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center">
      <XCircle className="w-16 h-16 mx-auto text-gray-500" />
      <h1 className="font-display text-5xl mt-4">CHECKOUT CANCELLED</h1>
      <p className="mt-2 text-gray-400">No worries — your order was not placed and your card was not charged. Your cart is still saved.</p>
      <Link to="/checkout" data-testid="cancel-return-cart" className="inline-block mt-8 bg-[var(--gv-blue)] hover:bg-[var(--gv-blue-bright)] text-black px-8 py-4 font-bold uppercase tracking-widest text-sm transition-colors">Return to Cart</Link>
    </div>
  );
}
